import { useState, useRef } from 'react'
import service from '../../../@services'

const defaultPageData = {
  pageCount: 0,
  pageIndex: 1,
  pageSize: 10,
  recordCount: 0,
  result: []
}
export default function useGetCheckDetailProductList() {
  const [pageData, setPageData] = useState(defaultPageData)
  const [loading, setLoading] = useState(false)
  const baseQueryParams = useRef(null)
  const getList = async params => {
    if (params.formDate) baseQueryParams.current = params.formDate
    setLoading(true)
    try {
      let _listData = await service.inventory.getCheckSheetDeailProductList({
        checkNo: params.checkNo,
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
        ...baseQueryParams.current
      })
      setLoading(false)

      _listData && setPageData(_listData)
    } catch (error) {
      setLoading(false)
      if (params.formDate) setPageData(defaultPageData)
    }
  }
  return {
    pageData,
    getList,
    loading
  }
}
